import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { MailIcon } from 'lucide-react';
export function Contact() {
  return <>
      <Helmet data-id="element-1332">
        <title data-id="element-1333">Contact Bright Pixxel Studios | Web Design Enquiries</title>
        <meta name="description" content="Contact Bright Pixxel Studios for web design, e-commerce and ongoing website care. We reply within 24 hours." data-id="element-1334" />
      </Helmet>
      <section className="pt-32 pb-16 bg-white dark:bg-[#F5F5F5] min-h-screen" data-id="element-1335">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1336">
          <div className="max-w-6xl mx-auto" data-id="element-1337">
            {/* Header */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="text-center mb-12" data-id="element-1338">
              <h1 className="text-3xl md:text-5xl font-bold mb-4 text-[#0C1B26] dark:text-[#0C1B26]" data-id="element-1339">
                Contact Bright Pixxel Studios
              </h1>
              <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-1340">
                We're here to help. Email us directly and we'll respond within
                24 hours.
              </p>
            </motion.div>
            {/* Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-1341">
              {/* Left: Illustration */}
              <motion.div initial={{
              opacity: 0,
              x: -30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6
            }} className="order-2 lg:order-1" data-id="element-1342">
                <div className="relative bg-[#212C34] rounded-2xl p-8 md:p-12 shadow-lg" data-id="element-1343">
                  <div className="relative z-10" data-id="element-1344">
                    <img src="https://images.unsplash.com/photo-1596526131083-e8c633c948d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Contact us illustration - email communication" className="w-full h-auto rounded-lg" loading="eager" data-id="element-1345" />
                  </div>
                  {/* Decorative elements */}
                  <div className="absolute top-4 right-4 w-20 h-20 bg-[#0DC3DC]/20 rounded-full blur-2xl" data-id="element-1346"></div>
                  <div className="absolute bottom-4 left-4 w-32 h-32 bg-[#0DC3DC]/10 rounded-full blur-3xl" data-id="element-1347"></div>
                </div>
              </motion.div>
              {/* Right: Email Card */}
              <motion.div initial={{
              opacity: 0,
              x: 30
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="order-1 lg:order-2" data-id="element-1348">
                <div className="bg-[#212C34] rounded-2xl p-8 md:p-10 shadow-xl" data-id="element-1349">
                  {/* Email Icon */}
                  <div className="w-16 h-16 bg-[#0DC3DC]/20 rounded-full flex items-center justify-center mb-6" data-id="element-1350">
                    <MailIcon size={32} className="text-[#0DC3DC]" data-id="element-1351" />
                  </div>
                  {/* Email Address */}
                  <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-1352">
                    Email Us
                  </h2>
                  <a href="mailto:info@bright-pixxel.com" className="text-xl md:text-2xl text-[#0DC3DC] hover:text-[#0DC3DC]/80 transition-colors mb-6 block break-all" data-id="element-1353">
                    info@bright-pixxel.com
                  </a>
                  {/* Send Email Button */}
                  <a href="mailto:info@bright-pixxel.com?subject=Website Enquiry - Bright Pixxel Studios" className="w-full inline-flex items-center justify-center bg-[#0DC3DC] hover:bg-[#0DC3DC]/90 text-white px-8 py-4 rounded-lg font-bold transition-all duration-300 shadow-lg hover:shadow-[0_0_20px_rgba(13,195,220,0.4)] mb-6" data-id="element-1354">
                    <MailIcon size={20} className="mr-2" data-id="element-1355" />
                    Send Email
                  </a>
                  {/* Working Hours */}
                  <div className="pt-4 border-t border-white/10" data-id="element-1356">
                    <p className="text-white/90 text-sm mb-2 font-semibold" data-id="element-1357">
                      Working Hours
                    </p>
                    <p className="text-white/70 text-sm mb-1" data-id="element-1358">
                      Monday – Friday: 9:00 AM – 5:00 PM (UK time)
                    </p>
                    <p className="text-white/70 text-sm mb-3" data-id="element-1359">
                      Saturday & Sunday: Closed
                    </p>
                    <p className="text-[#0DC3DC] text-sm font-medium" data-id="element-1360">
                      ✓ We reply to all emails within 24 hours
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
    </>;
}